module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("6lRUQ"))).then(() => parcelRequire('5erN3'));